export default __webpack_public_path__ + "static/difiLogoBiggerText-426f5060e7f6917323214cf6309eb61a.png";